
function All () {}
All.prototype = {
  timer: '',
  operationMap: {
    in: '包含',
    notIn: '不包含'
  },
  execTypeMap: {
    2: '会签',
    3: '或签',
    '': ''
  },
  debounce (fn, delay = 500) {
    const _this = this;
    return function (arg) {
      // 获取函数的作用域和变量
      const that = this;
      const args = arg;
      clearTimeout(_this.timer); // 清除定时器
      _this.timer = setTimeout(function () {
        fn.call(that, args);
      }, delay);
    };
  },
  setCookie (val) { // cookie设置[{key:value}]、获取key、清除['key1','key2']
    for (let i = 0, len = val.length; i < len; i++) {
      for (const key in val[i]) {
        document.cookie = `${key}=${encodeURIComponent(val[i][key])}; path=/`;
      }
    }
  },
  getCookie (name) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0, len = arrCookie.length; i < len; i++) {
      const arr = arrCookie[i].split('=');
      if (name == arr[0]) {
        return decodeURIComponent(arr[1]);
      }
    }
  },
  clearCookie (name) {
    const myDate = new Date();
    myDate.setTime(-1000); // 设置时间
    for (let i = 0, len = name.length; i < len; i++) {
      document.cookie = `${name[i]}=''; path=/; expires=${myDate.toGMTString()}`;
    }
  },
  arrToStr (arr) {
    if (arr) {
      return arr.map(item => item.name).toString();
    }
  },
  toggleClass (arr, elem, key = 'id') {
    return arr.some(item => item[key] == elem[key]);
  },
  toChecked (arr, elem, key = 'id') {
    const isIncludes = this.toggleClass(arr, elem, key);
    !isIncludes ? arr.push(elem) : this.removeEle(arr, elem, key);
  },
  removeEle (arr, elem, key = 'id') {
    let includesIndex;
    arr.forEach((item, index) => {
      if (item[key] == elem[key]) {
        includesIndex = index;
      }
    });
    arr.splice(includesIndex, 1);
  },
  setApproverStr (nodeConfig) {
    // 审批人展示逻辑
    /**
     * 当审批人为指定人员时：
     *  如果是依次审批的时候一次展示 name,name,name...
     *  如果多人会签或者或签时，则展示 多少人 会签/或签
     */
    /**
     * 当审批人为部门时
     *  若指定一个或多个部门为会签或者或签时，得展示多少人会签或者或签
     */
    /**
     * 当审批人为角色时
     *  角色+会签/或签
     */
    /**
     * 当审批人为部门主管时
     *  若指定n级部门 + 会签/或签
     */
    /**
     * 当审批人为直属主管时
     *  汇报线N级主管
     */
    const { auditType, userType, nodeUserList = [], execType, departmentPersonNum = 0, nodeExecUsers = [] } = nodeConfig;
    switch (auditType) {
      case 1:
        // 如果是指定人员||指定部门||指定角色 显示选择的人员部门或角色
        // 如果是部门主管 || 部门主管 显示选择的几级主管
        if (userType == 1) {
          // 指定人员
          const titleList = nodeUserList.map(item => item.title);
          const titleLen = titleList.length;
          if (execType == 2) {
            // 会签
            return titleList.length > 1 ? `${titleLen}人会签` : titleList[0];
          } else if (execType == 3) {
            // 或签
            return titleList.length > 1 ? `${titleLen}人或签` : titleList[0];
          } else {
            // 依次审批
            return Array.isArray(titleList) && titleList.length > 0 ? titleList.join(',') : '';
          }
        } else if (userType == 2) {
          // 指定部门
          if (Array.isArray(nodeUserList) && nodeUserList.length > 0) {
            return `${departmentPersonNum}人${this.execTypeMap[execType]}`;
          }
          return '';
        } else if (userType == 3) {
          // 指定角色
          const titleList = nodeUserList.map(item => item.title);
          if (execType == 2 || execType == 3) {
            // 会签
            return titleList.length > 0 ? `${titleList.join(',')}${this.execTypeMap[execType]}` : '';
          }
          return titleList.join(',');
        } else if (userType == 4) {
          // 部门主管
          const level = nodeExecUsers[0];
          if (!level && level != 0) return '';
          const title = level == 0 ? '直接主管' : `${+level + 1}级主管`;
          // 或签
          if (execType == 2 || execType == 3) {
            return `${title}${this.execTypeMap[execType]}`;
          } else {
            return title;
          }
        } else if (userType == 5) {
          // 直属主管
          const level = nodeExecUsers[0];
          if (!level && level != 0) return '';
          const title = level == 0 ? '直属主管' : `${+level + 1}级主管`;
          return `汇报线${title}`;
        }
        return '';
      case 2:
        return '自动通过';
      case 3:
        return '自动拒绝';
      default:
        return '';
    }
  },
  dealStr (str, obj) {
    const arr = [];
    const list = str.split(',');
    for (const elem in obj) {
      list.forEach(item => {
        if (item == elem) {
          arr.push(obj[elem].value);
        }
      });
    }
    return arr.join('或');
  },
  getConditionStrByList (data = []) {
    const orString = data.map(or => {
      // 先把且拼接 #{money}  > 1000 and #{amunt} < 10
      const andStringArr = or.map(and => {
        const { label, operator, value } = and;
        return `${label} ${operator} ${value}`;
      });
      const andString = andStringArr.join(' 且 ');
      return `(${andString})`;
    });
    const useData = orString.join(' 或 ');
    return useData;
  },
  conditionStr (nodeConfig, index) {
    const { boolSpelExpression, boolSpelExpressionList } = nodeConfig.branchList[index];
    if (!boolSpelExpression) {
      return '请设置条件';
    }
    if (boolSpelExpression === true) {
      return '其他条件';
    }
    const string = this.getConditionStrByList(boolSpelExpressionList);
    return string;
  },
  copyerStr (nodeConfig) {
    // 抄送人逻辑
    /**
     * 当选择为部门、人员、角色时
     *  展示为选择的部门、人员、角色
     */
    /**
     * 当选择为部门主管或直属部门时
     *  展示几级部门主管
     */
    const { nodeUserList = [], userType, nodeExecUsers = [] } = nodeConfig;
    // 如果是部门人员或者角色时
    if ([1, 2, 3].includes(userType)) {
      if (nodeUserList && nodeUserList.length > 0) {
        const titleArr = nodeUserList.map(item => item.title);
        return titleArr.join(',');
      } else {
        return '';
      }
    } else {
      // 部门主管或者直属主管
      const level = nodeExecUsers[0];
      if (!level && level != 0) return '';
      if (userType == 4) {
        // 部门主管
        const title = level == 0 ? '直接主管' : `${+level + 1}级主管`;
        return title;
      }
      if (userType == 5) {
        const title = level == 0 ? '直属主管' : `${+level + 1}级主管`;
        return title;
      }
    }
  },
  toggleStrClass (item, key) {
    const a = item.zdy1 ? item.zdy1.split(',') : [];
    return a.some(item => item == key);
  },
  setPromoterStr (nodeConfig) {
    const { nodeUserList } = nodeConfig;
    if (nodeUserList && nodeUserList.length > 0) {
      const title = nodeUserList.map(item => item.title);
      return title.join(',');
    }
    return '';
  },
  setTransactorStr (nodeConfig) {
    // 办理人逻辑
    /**
     * 当办理人为指定人员时
     *  如果单人时，展示单人姓名
     *  如果是多人且为依次审批，展示姓名
     *  如果是多人且为会签，展示 n 人会签
     *  如果是多人且为或签，展示 n 人或签
     */
    /**
     * 当办理人为指定部门时
     *  若指定一个或者多个部门会签时，展示 n 人会签
     *  若指定一个或者多个部门或签时，展示 n 人或签
     */
    /**
     * 当办理人为指定角色时
     *  若指定一个角色且为会签 展示 角色+会签
     *  若指定一个橘色且为或签 展示 角色+或签
     */
    /**
     * 当办理人为部门主管时
     *  若指定n级部门且为会签 展示 n 级部门会签
     *  若指定n级部门且为或签 展示 n 级部门或签
     */
    /**
     * 当办理人为直属主管
     *  展示汇报线N级主管
     */
    const { userType, nodeUserList = [], execType, departmentPersonNum = 0, nodeExecUsers = [] } = nodeConfig;

    // 如果是指定人员||指定部门||指定角色 显示选择的人员部门或角色
    // 如果是部门主管 || 部门主管 显示选择的几级主管
    if (userType == 1) {
      // 指定人员
      const titleList = nodeUserList.map(item => item.title);
      const titleLen = titleList.length;
      if (execType == 2 || execType == 3) {
        // 会签
        return titleList.length > 1 ? `${titleLen}人${this.execTypeMap[execType]}` : titleList[0];
      } else {
        // 依次审批
        return Array.isArray(titleList) && titleList.length > 0 ? titleList.join(',') : '';
      }
    } else if (userType == 2) {
      // 指定部门
      if (Array.isArray(nodeUserList) && nodeUserList.length > 0) {
        return `${departmentPersonNum}人${this.execTypeMap[execType]}`;
      }
      return '';
    } else if (userType == 3) {
      // 指定角色
      const titleList = nodeUserList.map(item => item.title);
      if (execType == 2 || execType == 3) {
        // 会签
        return titleList.length > 0 ? `${titleList.join(',')}${this.execTypeMap[execType]}` : '';
      }
      return titleList.join(',');
    } else if (userType == 4) {
      // 部门主管
      const level = nodeExecUsers[0];
      if (!level && level != 0) return '';
      const title = level == 0 ? '直接主管' : `${+level + 1}级主管`;
      // 或签
      if (execType == 2 || execType == 3) {
        return `${title}${this.execTypeMap[execType]}`;
      } else {
        return title;
      }
      // 会签
    } else if (userType == 5) {
      // 直属主管
      const level = nodeExecUsers[0];
      if (!level && level != 0) return '';
      const title = level == 0 ? '直属主管' : `${+level + 1}级主管`;
      return `汇报线${title}`;
    }
    return '';
  },
  // 校验是否是有条件一样的名称
  checkRepeatCondition (nodeConfig) {
    const { branchList = [] } = nodeConfig;
    const nodeNameArr = branchList.map(condition => condition.nodeName);
    const newNodeNameArr = [...new Set(nodeNameArr)];
    return nodeNameArr.length != newNodeNameArr.length;
  }
};

export default new All();
